/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_CommissionsInputs */

const en_nav_commissions = /** @type {(inputs: Nav_CommissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commissions`)
};

const es_nav_commissions = /** @type {(inputs: Nav_CommissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comisiones`)
};

/**
* | output |
* | --- |
* | "Commissions" |
*
* @param {Nav_CommissionsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_commissions = /** @type {((inputs?: Nav_CommissionsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_CommissionsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_commissions(inputs)
	return es_nav_commissions(inputs)
});